import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../constants/axiosInstance";
import { remoteControlKeys } from "../../../modules/remote-control/utils/query-keys";

interface TriggerAlarmPayload {
  plantId: string;
}

const triggerPlantAlarm = async ({ plantId }: TriggerAlarmPayload): Promise<any> => {
  const { data } = await axiosInstance().post('/biDirectionalControl/createAndProcessTrigger', {
    assetId: plantId,
    plantId,
    controlValue: '1',
  });
  return data;
};

export const useTriggerPlantAlarm = () => {
  const queryClient = useQueryClient();

  const { mutate, isPending, isSuccess, isError, error } = useMutation({
    mutationFn: (payload: TriggerAlarmPayload) => triggerPlantAlarm(payload),
    onError: () => {
      queryClient.invalidateQueries({ queryKey: remoteControlKeys.all });
    },
  });

  return {
    triggerAlarm: mutate,
    isTriggering: isPending,
    isSuccess,
    isError,
    error,
  };
};
